<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {}
</script>
<style>
.v-stepper,
.v-stepper__header {
  box-shadow: none !important;
}
.v-stepper__step__step .v-icon.v-icon {
  font-size: 0.6rem !important;
}

#app {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#custom-content img {
  width: 100%;
}

.list_counter_validator > .v-input__control > .v-input__slot {
  display: none !important;
}
.list_counter_validator > .v-input__control > .v-messages {
  font-size: inherit;
}

@media screen and (max-width: 600px) {
  .v-btn-toggle {
    flex-direction: column;
  }
}
</style>
